import { useMsal } from "@azure/msal-react";
import { addLocale } from "primereact/api";
import { useEffect, useRef, useState } from "react";
import Dialog from "../components/Dialog";
import DialogMessage from "../components/DialogMessage";
import { ptBrDatepickerTranslations } from "../i18n/locales/pt-br";
import DialogMessageProps from "../model/DialogMessageProps";
import AceiteTermoDTO from "../model/dto/AceiteTermoDTO";
import { TermoDiretrizEnum } from "../model/Enums/TermoDiretrizEnum";
import { TypeDialogMessageEnum } from "../model/Enums/TypeDialogMessageEnum";
import AcceptanceTermsService from "../service/Docente/AcceptanceTermsService";
import ButtonStyles from "../styles/components/ButtonStyles";
import GenericUtils from "../utils/GenericUtils";
import HtmlToReact from "../components/HtmlToReact";
import ModalAcceptPlanStyles from "../styles/components/ModalAcceptPlanStyles";
import { StyledFormCheck } from "../styles/MainStyles";
import useIsOverflow from "../hooks/UseIsOverflow";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary } = ButtonStyles;

interface IModalProps {
    open: boolean;
    onClose?: (callback?: any) => void;
    term: string;
}

const ModalAcceptPlan: React.FC<IModalProps> = ({ open, onClose, term }) => {
    return null;
};

// const ModalAcceptPlan: React.FC<IModalProps> = ({ open, onClose, term }) => {
//     const [dialogMessageProps, setDialogMessageProps] =
//         useState<DialogMessageProps>({} as DialogMessageProps);
//     const [isOnBottom, setIsOnBottom] = useState<boolean>(false);
//     const [isChecked, setIsChecked] = useState<boolean>(false);

//     const { instance } = useMsal();
//     const user = GenericUtils.getUser();
//     const termRef = useRef<HTMLDivElement>(null);
//     // eslint-disable-next-line @typescript-eslint/no-unused-vars
//     const isOverflow = useIsOverflow(termRef);

//     const handleCloseDialogMessage = () => {
//         if (dialogMessageProps.type === TypeDialogMessageEnum.Success)
//             onClose?.();

//         setDialogMessageProps({} as DialogMessageProps);
//     };

//     const dialogMessage = dialogMessageProps.show && (
//         <DialogMessage
//             type={dialogMessageProps.type}
//             show={dialogMessageProps.show}
//             title={dialogMessageProps.title}
//             text={dialogMessageProps.text}
//             onClose={handleCloseDialogMessage}
//         />
//     );

//     const handleAceptPlan = async () => {
//         const aceiteTermoDTO = GenericUtils.impl<AceiteTermoDTO>({
//             termoDiretrizId: TermoDiretrizEnum.GestaoCargaHoraria,
//             login: user.docente?.matriculaAdp,
//         });

//         const response = await AcceptanceTermsService.saveUserAcceptance(
//             aceiteTermoDTO,
//             instance
//         );

//         if (GenericUtils.isSuccessStatus(response)) {
//             onClose?.();
//         } else {
//             setDialogMessageProps(
//                 GenericUtils.getPropsDialogError(response, {
//                     title: "Erro ao assinar",
//                 })
//             );
//         }
//     };

//     const checkIfScrollReachTheBottom = (event: any) => {
//         if (
//             event.target.scrollHeight - event.target.scrollTop - 50 <=
//             event.target.clientHeight
//         ) {
//             setIsOnBottom(true);
//         }
//     };

//     const handleCheckboxChange = (event: any) => {
//         setIsChecked(event.target.checked);
//     };

//     useEffect(() => {
//         setIsOnBottom(!isOverflow);
//     }, [isOverflow]);

//     return (
//         <Dialog
//             openModal={open}
//             onHide={onClose}
//             size="width-1000 modal-white modal-radius-8"
//             closeModal={false}
//         >
//             <ModalAcceptPlanStyles.ModalAcceptPlanHeader>
//                 <ModalAcceptPlanStyles.ModalAcceptPlanTitle>
//                     Termo de Aceite
//                 </ModalAcceptPlanStyles.ModalAcceptPlanTitle>
//             </ModalAcceptPlanStyles.ModalAcceptPlanHeader>
//             <ModalAcceptPlanStyles.ModalAcceptPlanWrapper
//                 onScroll={checkIfScrollReachTheBottom}
//                 ref={termRef}
//             >
//                 <HtmlToReact htmlString={term} />
//             </ModalAcceptPlanStyles.ModalAcceptPlanWrapper>
//             <ModalAcceptPlanStyles.ModalAcceptPlanActionsWrapper>
//                 <StyledFormCheck
//                     type="checkbox"
//                     checked={isChecked}
//                     label="Li e aceito os termos acima"
//                     onChange={handleCheckboxChange}
//                     className="checkbox"
//                     disabled={!isOnBottom}
//                 />
//                 <BtnPrimary onClick={handleAceptPlan} disabled={!isChecked}>
//                     Aceitar
//                 </BtnPrimary>
//             </ModalAcceptPlanStyles.ModalAcceptPlanActionsWrapper>
//             {dialogMessage}
//         </Dialog>
//     );
// };

export default ModalAcceptPlan;
